const initialState = {
  touch: false,
  value: '',
};

const tabTouch = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_TAB_TOUCH':
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default tabTouch;
